module.exports = __webpack_public_path__ + "img/icon4.474fc28a.svg";